var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "usp-list" }, [
    _vm.availability
      ? _c(
          "div",
          {
            class: [_vm.classes, "availability-top"],
            style: _vm.paddingStyles,
          },
          [
            _c("i", { staticClass: "fa fa-clock-o" }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "text-wrap",
                class: {
                  "text-dark": _vm.availability && _vm.availability.id === 2,
                },
              },
              [_vm._v("\n            " + _vm._s(_vm.name) + "\n        ")]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }